import styled from '@emotion/styled';

interface IProps {
	gap: string;
	error: boolean;
}

export const Container = styled.div<IProps>`
	display: flex;
	flex-direction: column;
	gap: ${(props: IProps) => props.gap};
	width: 100%;

	input,
	textarea {
		border-color: ${(props) => (props.error ? props.theme.colors.red600 : undefined)};
	}
`;

export const ErrorMsg = styled.p`
	margin: 0;
	font-size: ${(props) => props.theme.fontSize.size2xs};
	color: ${(props) => props.theme.colors.red600};
	line-height: 1.4;
`;

export const Label = styled.label`
	font-size: ${(props) => props.theme.ui.form.labelFontSize};
	font-weight: ${(props) => props.theme.ui.form.labelFontWeight};
	line-height: 1.3;
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.tight};
	color: ${(props) => props.theme.ui.text.primary};
`;
